<template>
  <v-select
      :items="options"
      v-model="priority"
      outlined
      hide-details="auto"
      :rules="rules"
      style="max-width: 15em"
  ></v-select>
</template>

<script>
export default {
  name: 'ServiceRequestStateSelect',
  props: {
    value: {
      required: true,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  computed: {

    priority: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },

    options() {
      const states = ['NEW', 'REJECTED', 'ACCEPTED', 'DONE'];
      return states.map(state => {
        return {
          text: this.$options.filters.serviceRequestState(state),
          value: state,
        };
      });
    },
  },
};
</script>
